export default __webpack_public_path__ + "static/media/Demon Mantle of the Living Legend.35c2c35c.jpg";